module.exports = __webpack_public_path__ + "static/img/about_3.63bbd8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_3.png
// module id = 65Hs
// module chunks = 1